import { render, staticRenderFns } from "./LoyaltySubscriptionAddComponent.vue?vue&type=template&id=21c8ff34&scoped=true"
import script from "./LoyaltySubscriptionAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltySubscriptionAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8ff34",
  null
  
)

export default component.exports